/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopVideoCall = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopVideoCall model module.
   * @module model/WorkshopVideoCall
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopVideoCall</code>.
   * @alias module:model/WorkshopVideoCall
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>WorkshopVideoCall</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopVideoCall} obj Optional instance to populate.
   * @return {module:model/WorkshopVideoCall} The populated <code>WorkshopVideoCall</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('WorkshopID')) {
        obj['WorkshopID'] = ApiClient.convertToType(data['WorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('RoomIdentifier')) {
        obj['RoomIdentifier'] = ApiClient.convertToType(data['RoomIdentifier'], 'String');
      }
      if (data.hasOwnProperty('HostRoomUrl')) {
        obj['HostRoomUrl'] = ApiClient.convertToType(data['HostRoomUrl'], 'String');
      }
      if (data.hasOwnProperty('ParticipantRoomUrl')) {
        obj['ParticipantRoomUrl'] = ApiClient.convertToType(data['ParticipantRoomUrl'], 'String');
      }
      if (data.hasOwnProperty('StartAutomatically')) {
        obj['StartAutomatically'] = ApiClient.convertToType(data['StartAutomatically'], 'Boolean');
      }
      if (data.hasOwnProperty('IsWebinar')) {
        obj['IsWebinar'] = ApiClient.convertToType(data['IsWebinar'], 'Boolean');
      }
      if (data.hasOwnProperty('RoomExpirationDate')) {
        obj['RoomExpirationDate'] = ApiClient.convertToType(data['RoomExpirationDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} WorkshopID
   * @default 0
   */
  exports.prototype['WorkshopID'] = 0;
  /**
   * @member {String} RoomIdentifier
   * @default ''
   */
  exports.prototype['RoomIdentifier'] = '';
  /**
   * @member {String} HostRoomUrl
   * @default ''
   */
  exports.prototype['HostRoomUrl'] = '';
  /**
   * @member {String} ParticipantRoomUrl
   * @default ''
   */
  exports.prototype['ParticipantRoomUrl'] = '';
  /**
   * @member {Boolean} StartAutomatically
   * @default false
   */
  exports.prototype['StartAutomatically'] = false;
  /**
   * @member {Boolean} IsWebinar
   * @default false
   */
  exports.prototype['IsWebinar'] = false;
  /**
   * @member {Date} RoomExpirationDate
   */
  exports.prototype['RoomExpirationDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


